import { createGlobalState } from '@vueuse/core';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { DomNodesTipService } from './dom-nodes-tip';
import { reactive } from 'vue';

export const useDomNodesTip = createGlobalState(() => {
    const domNodesTipService = reactive(injectService<DomNodesTipService>(DomNodesTipService));

    const setTipRef = ({ ref, id }: { ref: HTMLElement, id: string }) => {
        domNodesTipService.setTipRef({ ref, id });
    };

    const setWrapperRef = ({ ref, id }: { ref: HTMLElement, id: string }) => {
        domNodesTipService.setWrapperRef({ ref, id });
    };

    const clearTip = (id: string) => {
        domNodesTipService.clearTip(id);
    };

    const initNodesTip = (params: {
        notFoundMessage?: string,
        selector: string,
    }) => {
        domNodesTipService.initNodesTip(params);
    };

    const closeTip = (id: string) => {
        domNodesTipService.closeTip(id);
    };

    const moveToTargetNode = (params: {
        targetIdx?: number,
        moveType?: 'next' | 'prev',
        id: string,
    }) => {
        domNodesTipService.moveToTargetNode(params);
    };

    return {
        domNodesTipService,

        setTipRef,
        setWrapperRef,
        clearTip,
        initNodesTip,
        closeTip,
        moveToTargetNode,
    };
});
